import { Navigate, Outlet } from 'react-router-dom'

import { DashboardSkeleton } from '@/components/dashboard/DashboardSkeleton'
import { AppHeader } from '@/components/layout/AppHeader'
import { AuthSplash } from '@/components/layout/AuthSplash'
import { useAuth } from '@/contexts/AuthContext'
import { NotAuthorized } from '@/pages/NotAuthorized'

function DashboardLoadingLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-page">
      <AppHeader showUserSkeleton />
      <main className="flex-1">
        <DashboardSkeleton />
      </main>
    </div>
  )
}

export function ProtectedRoute() {
  const { user, loading, isAuthorizedRiskUser } = useAuth()

  // Auth is still resolving — we don't yet know whether there's a session. Show a neutral splash
  // rather than committing to a page: redirecting to /login here flashed the sign-in screen to
  // already-signed-in visitors on refresh (Firebase restores the session asynchronously) before
  // bouncing them back, and rendering the dashboard skeleton would leak the portal to signed-out
  // users. LoginRoute shows the same splash, so there's no cross-route jump either way.
  if (loading) {
    return <AuthSplash />
  }

  // Resolved and no session — send to the login page.
  if (!user) {
    return <Navigate to="/login" replace />
  }

  // Signed in: keep the dashboard skeleton up until risk-assessment authorization resolves.
  if (isAuthorizedRiskUser === null) {
    return <DashboardLoadingLayout />
  }

  if (isAuthorizedRiskUser === false) {
    return <NotAuthorized />
  }

  return <Outlet />
}
